// store/modules/dashboard.js
import { apiDataService } from "@/services/apiDataService";

export default {
	namespaced: true,

	state: {
		kpis: null,
		charts: [],
		topEvents: [],
		dashboardType: null, // 'org' | 'admin'
		loading: {
			dashboard: false,
			categories: false,
			attendants: false,
		},
	},

	mutations: {
		SET_DASHBOARD_TYPE(state, type) {
			state.dashboardType = type;
		},
		SET_KPIS(state, kpis) {
			state.kpis = kpis;
		},
		SET_CHARTS(state, charts) {
			state.charts = charts || [];
		},
		SET_TOP_EVENTS(state, events) {
			state.topEvents = events || [];
		},
		SET_LOADING(state, { key, value }) {
			state.loading[key] = value;
		},
	},

	actions: {
		async fetchAnalytics(
			{ state, rootState, commit },
			{ forceRefresh = false } = {}
		) {
			if (state.kpis && !forceRefresh) return;

			commit("SET_LOADING", { key: "dashboard", value: true });

			try {
				const userInfo = rootState.auth.user;
				if (!userInfo) throw new Error("User info not found");

				const apiResponse = await apiDataService.getOrganizationAnalytics();
				const data = apiResponse.data;
				
				//  ADMIN DASHBOARD
				if (userInfo.user_type === 0) {
					const admin = data.admin_dashboard.platform;

					commit("SET_DASHBOARD_TYPE", "admin");
					commit("SET_KPIS", admin.kpis);
					commit("SET_CHARTS", admin.charts || []);
					commit("SET_TOP_EVENTS", admin.top_performing_events || []);
				}
				//  ORGANIZATION DASHBOARD
				else {
					const org = data.org_dashboard.organization;

					commit("SET_DASHBOARD_TYPE", "org");
					commit("SET_KPIS", org.kpis);
					commit("SET_CHARTS", org.charts?.charts || []);
					commit("SET_TOP_EVENTS", org.top_performing_events || []);
				}
			} catch (error) {
				console.error("Dashboard fetch failed:", error);
				commit("SET_KPIS", null);
				commit("SET_CHARTS", []);
				commit("SET_TOP_EVENTS", []);
			} finally {
				commit("SET_LOADING", { key: "dashboard", value: false });
			}
		},
	},

	getters: {
		kpis: (state) => state.kpis,

		totalEvents: (state) => state.kpis?.total_events_created || 0,
		totalTicketsSold: (state) => state.kpis?.total_tickets_sold || 0,
		revenueGenerated: (state) => state.kpis?.revenue_generated || 0,
		attendeesCount: (state) => state.kpis?.total_attendees_registered || 0,

		charts: (state) => state.charts,

		chartByMetric: (state) => (metric) =>
			state.charts.find((c) => c.metric === metric),

		topEvents: (state) => state.topEvents,

		isAdminDashboard: (state) => state.dashboardType === "admin",
	},
};
